<template>
  <v-dialog v-model="visible" max-width="900px" scrollable>
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">Criterios de selección de inscripciones</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th>Tipo</th>
                <th>Categoría</th>
                <th>Estado</th>
                <th>Significado</th>
              </tr>
            </thead>
            <tbody>
              <!-- Estados Académicos válidos -->
              <tr v-for="(estado, index) in estadosAcademicosValidos" :key="'av-' + index">
                <td v-if="index === 0" :rowspan="estadosAcademicosValidos.length">Académico</td>
                <td v-if="index === 0" :rowspan="estadosAcademicosValidos.length">
                  <v-chip small dark color="green">Válido</v-chip>
                </td>
                <td>
                  <v-chip small dark :color="coloresEstadosAcademicos[estado]">{{ estado }}</v-chip>
                </td>
                <td>Seleccionable</td>
              </tr>

              <!-- Estados de Cartera válidos -->
              <tr v-for="(estado, index) in estadosCarteraValidos" :key="'cv-' + index">
                <td v-if="index === 0" :rowspan="estadosCarteraValidos.length">Cartera</td>
                <td v-if="index === 0" :rowspan="estadosCarteraValidos.length">
                  <v-chip small dark color="green">Válido</v-chip>
                </td>
                <td>
                  <v-chip small dark :color="coloresEstadosCartera[estado]">{{ estado }}</v-chip>
                </td>
                <td>Seleccionable</td>
              </tr>

              <!-- Estados Académicos observados -->
              <tr v-for="(estado, index) in estadosAcademicosObservados" :key="'ao-' + index">
                <td v-if="index === 0" :rowspan="estadosAcademicosObservados.length">Académico</td>
                <td v-if="index === 0" :rowspan="estadosAcademicosObservados.length">
                  <v-chip small dark color="orange">Observado</v-chip>
                </td>
                <td>
                  <v-chip small dark :color="coloresEstadosAcademicos[estado]">{{ estado }}</v-chip>
                </td>
                <td>A criterio del usuario</td>
              </tr>

              <!-- Estados de Cartera observados -->
              <tr v-for="(estado, index) in estadosCarteraObservados" :key="'co-' + index">
                <td v-if="index === 0" :rowspan="estadosCarteraObservados.length">Cartera</td>
                <td v-if="index === 0" :rowspan="estadosCarteraObservados.length">
                  <v-chip small dark color="orange">Observado</v-chip>
                </td>
                <td>
                  <v-chip small dark :color="coloresEstadosCartera[estado]">{{ estado }}</v-chip>
                </td>
                <td>A criterio del usuario</td>
              </tr>

              <!-- Estados de Portal inválidos -->
              <tr v-for="(estado, index) in estadosPortalInvalidos" :key="'pi-' + index">
                <td v-if="index === 0" :rowspan="estadosPortalInvalidos.length">Portal</td>
                <td v-if="index === 0" :rowspan="estadosPortalInvalidos.length">
                  <v-chip small dark color="red">Inválido</v-chip>
                </td>
                <td>
                  <v-chip small dark :color="coloresEstadosInscripcion[estado.codigo]">{{ estado.nombre }}</v-chip>
                </td>
                <td>No seleccionable</td>
              </tr>

              <!-- Estados Académicos inválidos -->
              <tr v-for="(estado, index) in estadosAcademicosInvalidos" :key="'ai-' + index">
                <td v-if="index === 0" :rowspan="estadosAcademicosInvalidos.length">Académico</td>
                <td v-if="index === 0" :rowspan="estadosAcademicosInvalidos.length">
                  <v-chip small dark color="red">Inválido</v-chip>
                </td>
                <td>
                  <v-chip small dark :color="coloresEstadosAcademicos[estado]">{{ estado }}</v-chip>
                </td>
                <td>No seleccionable</td>
              </tr>

              <!-- Estado de Cartera inválido -->
              <tr v-for="(estado, index) in estadosCarteraInvalidos" :key="'ci-' + index">
                <td v-if="index === 0" :rowspan="estadosCarteraInvalidos.length">Cartera</td>
                <td v-if="index === 0" :rowspan="estadosCarteraInvalidos.length">
                  <v-chip small dark color="red">Inválido</v-chip>
                </td>
                <td>
                  <v-chip small dark :color="coloresEstadosCartera[estado]">{{ estado }}</v-chip>
                </td>
                <td>No seleccionable</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { COLORES_ESTADOS_ACADEMICOS, COLORES_ESTADOS_CARTERA, COLORES_ESTADOS_INSCRIPCION } from '../utils/constantes';

export default {
  name: 'ModalCriteriosInscripciones',
  data() {
    return {
      visible: false,
      coloresEstadosAcademicos: COLORES_ESTADOS_ACADEMICOS,
      coloresEstadosCartera: COLORES_ESTADOS_CARTERA,
      coloresEstadosInscripcion: COLORES_ESTADOS_INSCRIPCION,
      estadosAcademicosValidos: ['Concluido Aprobado', 'Aprobado Trabajo Final', 'En Desarrollo', 'Presentado'],
      estadosCarteraValidos: ['Exento de deuda', 'Vigente'],
      estadosAcademicosObservados: ['En Desarrollo - Nivelacion', 'Grupo'],
      estadosCarteraObservados: ['Retrasado', 'En mora', 'Riesgo de incobrabilidad'],
      estadosPortalInvalidos: [
        { nombre: 'Retirado', codigo: 2 },
        { nombre: 'Preinscrito', codigo: 0 },
        { nombre: 'Congelado', codigo: 4 },
        { nombre: 'Cambiado', codigo: 3 },
      ],
      estadosAcademicosInvalidos: ['Modular', 'Abandono Académico', 'Retirado', 'Reprobado', 'Congelado'],
      estadosCarteraInvalidos: ['Liquidado - Exento de deuda'],
    };
  },
  methods: {
    abrir() {
      this.visible = true;
    },
    cerrar() {
      this.visible = false;
    },
  },
};
</script>
